import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from './Button';
interface ConfirmDialogProps {
  open: boolean; onClose: () => void; onConfirm: () => void;
  title: string; description: string; confirmLabel?: string; variant?: 'danger'|'primary';
  loading?: boolean;
}
export function ConfirmDialog({ open, onClose, onConfirm, title, description, confirmLabel, variant='danger', loading }: ConfirmDialogProps) {
  const { t } = useTranslation();
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" onClick={onClose}/>
      <div className="relative bg-white dark:bg-gray-800 rounded-2xl shadow-xl w-full max-w-md p-6">
        <button onClick={onClose} className="absolute top-4 end-4 text-gray-400 hover:text-gray-600"><X size={20}/></button>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">{title}</h2>
        <p className="text-sm text-gray-500 mb-6">{description}</p>
        <div className="flex gap-3 justify-end">
          <Button variant="outline" onClick={onClose}>{t('common.cancel')}</Button>
          <Button variant={variant} onClick={onConfirm} loading={loading}>{confirmLabel ?? t('common.confirm')}</Button>
        </div>
      </div>
    </div>
  );
}
